'use client';

import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const MessageListContext = /*#__PURE__*/React.createContext({
  isAtBottom: true,
  unseenMessageCount: 0,
  scrollToBottom: () => {}
});
if (process.env.NODE_ENV !== "production") MessageListContext.displayName = "MessageListContext";
export function MessageListContextProvider(props) {
  const {
    children,
    value
  } = props;
  return /*#__PURE__*/_jsx(MessageListContext.Provider, {
    value: value,
    children: children
  });
}
export function useMessageListContext() {
  return React.useContext(MessageListContext);
}